module.exports = __webpack_public_path__ + "static/media/checklist.8fa8ad2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/checklist.svg
// module id = 642
// module chunks = 0